export const dateFormat = (date = new Date()) => {
  return new Intl.DateTimeFormat(['pl'], {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date).replace(/\./g, '-')
}

export const addDays = days => date => {
  const result = new Date(date);

  result.setDate(result.getDate() + days);

  return result;
};
